import { useFieldArray, useFormContext } from "react-hook-form";
import { DomainButton } from "_components/Abstractions/DomainButton";
import { Card } from "react-bootstrap";
import { UsedContainerForm } from "./UsedContainerForm";
import { useEffect } from "react";

export function UsedContainersForm({ prefix, isAddressActive }) {
  const baseFieldName = "usedContainers";
  const fieldName = prefix ? `${prefix}.${baseFieldName}` : baseFieldName;
  const { getFieldState } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    name: fieldName,
  });

  const fieldState = getFieldState(fieldName);

  const addItem = () => {
    append({
      totalCount: null,
      subContainers: []
    });
  };

  const removeItem = (index) => {
    remove(index);
  };

  const controls = (
    <div className={`form-control domain-control ${fieldState?.error ? "is-invalid" : ""}`}>
      {fields.map((address, index) => (
        <div key={address.id}>
          <Card.Header>{`${index + 1}. Kontener `}</Card.Header>
          <Card.Body>
            <DeleteUsedContainersButton onRemove={() => removeItem(index)} isAddressActive={isAddressActive} />
            <div className="domain-control error">{fieldState?.error?.message}</div>
            <UsedContainerForm name={`${fieldName}[${index}]`} isAddressActive={isAddressActive}/>
          </Card.Body>
        </div>
      ))}
      <Card.Footer>
        <DomainButton className="mt-1" onClick={addItem} disabled={!isAddressActive}>Dodaj kontener</DomainButton>
      </Card.Footer>
    </div>
  );

  return <>{controls}</>;
}

const DeleteUsedContainersButton = ({ onRemove, isAddressActive }) => {
  useEffect(() => {
    if(isAddressActive === false) {
      onRemove();
    }
  }, [isAddressActive]);

  return (
    <DomainButton onClick={onRemove} className="mb-2">
      Usuń kontener
    </DomainButton>
  );
};